import { Breadcrumb } from 'antd'
import { useSelector } from 'react-redux'
import './BreadNav.scss'
import { getNavDataList } from '../Nav/NavData'

export const BreadNav = () => {
    const selectedKeys = useSelector(state => state.NavSlice.selectedKeys)
    const dataList = getNavDataList()
    const getPathName = () => {
        let result
        dataList.forEach(item => {
            item.children.forEach(itemSub => {
                if (itemSub.key === selectedKeys[0]) {
                    result = itemSub.label
                }
            })
        })
        return result
    }

    return (
        <Breadcrumb className='BreadNav'>
            <Breadcrumb.Item className='aTexts'>{getPathName()}</Breadcrumb.Item>
        </Breadcrumb>
    )
}
